import { mapEnumToOptions } from '@abp/ng.core';

export enum CustomerPropertySituationCh {
  Proprietaire = 0,
  Locataire = 1,
  NonRenseigne = -1,
}

export const customerPropertySituationChOptions = mapEnumToOptions(CustomerPropertySituationCh);
